export default "__VITE_ASSET__CBHCAmAU__"